export { default } from "./tabPanel";
